export class Profile {

	saveProfile(parent, confirmed = false)
	{
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		/*if (form.find('input[name=block_type]').val() == 'email' && !confirmed)
		{
			let input = form.find('input[name=str_email]');
			if (input.val() != input.attr('data-original'))
			{
				$(".popup-email").removeClass("active");
				$(".popup-email-edit").addClass("active");

				this.requestConfirm('phone');
				button.attr('disabled', false);
				return;
			}
		}

		if (form.find('input[name=block_type]').val() == 'phone' && !confirmed)
		{
			let input = form.find('input[name=str_phone]');
			if (input.val() != input.attr('data-original'))
			{
				$(".popup-tel").removeClass("active");
				$(".popup-tel-edit").addClass("active");

				this.requestConfirm('email');
				button.attr('disabled', false);
				return;
			}
		}*/

		$.ajax({
			url: "/ajax.php?mid=11",
			type: 'POST',
			data: form.serialize() + '&action=saveProfile',
			dataType: "json",
			success: function(res){
				button.attr('disabled', false);

				if (res['success'])
				{
					_this.hideMistake(form);
					//$('.profile-data__container').replaceWith(res['html']);
					_this.applyEvents();
					_this.hidePopup(form.closest('.popup'));

					if (confirmed)
					{
						_this.hidePopup($('.popup-email-edit'));
						_this.hidePopup($('.popup-tel-edit'));
					}
				}
				else
				{
					_this.showMistake(form, 'Ошибка: ' + res['error']);

					if (res['activate_link'])
					{
						$('#auth_block .form__mistakes').append('<p><a href="' + res['activate_link'] + '" target="_blank">Выслать код активации повторно</a></p>');
					}
				}
			},
			error: function(res){
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	sendRequest(parent)
	{
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: form.serialize() + '&action=sendRequest',
			dataType: "json",
			success: function(res){
				button.attr('disabled', false);

				if (res['success'])
				{
					_this.hideMistake(form);
					$(".popup-personal").removeClass("active");
					$(".popup-success-personal").addClass("active");
				}
				else
				{
					_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function(res){
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	changePwd(parent)
	{
		let _this = this;
		let form = $(parent);
		let button = form.find('button[type=submit]');
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: form.serialize() + '&action=changePwd',
			dataType: "json",
			success: function(res){
				button.attr('disabled', false);

				if (res['success'])
				{
					_this.hideMistake(form)
					_this.hidePopup(form.closest('.popup'));
					/* _this.hideMistake(form)
					$('.form__success').html('Пароль успешно сохранен').addClass('active');
					setTimeout(()=> {
						_this.hidePopup(form.closest('.popup'));
						$('.form__success').html('').removeClass('active');
					}, 2000); */

				}
				else
				{
					_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function(res){
				button.attr('disabled', false);
				_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	deleteAccount(parent)
	{
		let _this = this;
		let button = $(parent);
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {action: 'deleteAccount'},
			dataType: "json",
			success: function(res){
				button.attr('disabled', false);

				if (res['success'])
				{
					$('.profile-data__container').replaceWith(res['html']);
					_this.applyEvents();

					_this.hidePopup(button.closest('.popup'));
				}
				else
				{
					//_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function(res){
				button.attr('disabled', false);
				//_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	cancelDeleteAccount(parent)
	{
		let _this = this;
		let button = $(parent);
		button.attr('disabled', true);

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {action: 'cancelDeleteAccount'},
			dataType: "json",
			success: function(res){
				button.attr('disabled', false);

				if (res['success'])
				{
					$('.profile-data__container').replaceWith(res['html']);
					_this.applyEvents();

					_this.hidePopup(button.closest('.popup'));
				}
				else
				{
					//_this.showMistake(form, 'Ошибка: ' + res['error']);
				}
			},
			error: function(res){
				button.attr('disabled', false);
				//_this.showMistake(form, 'Ошибка отправки данных. Пожалуйста, попробуйте ещё раз или обратитесь к администратору сайта');
			}
		});
	}

	requestConfirm(type)
	{
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {action: 'requestConfirm', type: type},
			dataType: "json",
			success: function(res){
				_this.startTimer(type)
			},
			error: function(res){

			}
		});
	}

	checkConfirm(parent, type)
	{
		let _this = this;
		let code = $(parent).find('input').val();

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {action: 'checkConfirmCode', type: type, code: code},
			dataType: "json",
			success: function(res){
				if (res.success)
				{
					if (type == 'phone')
						type = 'email';
					else if (type == 'email')
						type = 'tel';

					_this.saveBlock($('.popup-' + type + ' form'), true);
				}
				else
				{
					_this.showMistake(parent, res.error);
				}
			},
			error: function(res){

			}
		});
	}

	startTimer(type)
	{
		if (type == 'phone')
			type = 'email';
		else if (type == 'email')
			type = 'tel';

		$('.popup-' + type + '-edit__repeat').fadeIn();
		$('.popup-' + type + '-edit__repeat-btn-wrapper').hide();
		let time = 59;
		$('.popup-' + type + '-edit__repeat-timer').text('00:' + (time < 10 ? '0' : '') + time);
		let intervalId = setInterval(function(){
			time--;
			$('.popup-' + type + '-edit__repeat-timer').text('00:' + (time < 10 ? '0' : '') + time);
			if (time == 0)
			{
				clearInterval(intervalId);
				$('.popup-' + type + '-edit__repeat-btn-wrapper').show();
			}
		}, 1000);
	}

	resendConfirmMail()
	{
		let _this = this;

		$.ajax({
			url: "/ajax.php?mid=10",
			type: 'POST',
			data: {action: 'resendConfirmMail'},
			dataType: "json",
			success: function(res){
				$("body").addClass("no-scroll");
				$(".popup-confirmation-email").addClass("active");
			},
			error: function(res){

			}
		});
	}

	showMistake(block, text)
	{
		$(block).find('.form__mistakes p').text(text);
		$(block).find('.form__mistakes').show();
	}

	hideMistake(block)
	{
		$(block).find('.form__mistakes p').text('');
		$(block).find('.form__mistakes').hide();
	}

	hidePopup(popup)
	{
		$("body").removeClass("no-scroll");
		popup.removeClass("active");
	}

	applyEvents()
	{
		let _this = this;
		$('.form.bills-operations__filter input').change(function(){
			_this.filter();
		});

		$("button.gifts-operations__item-qr").click(function (e){
			let li = $(this).closest('.gifts-operations__item');
			let id = li.attr('data-id');
			let html = li.find('.gifts-operations__item-hidden .gifts-operations__item-howtoget').html();
			let name = li.find('.gifts-operations__item-title').text();
			$(".popup-qr .gift-get-text").html(html);
			$(".popup-qr h3").text(name);
			if (li.attr('data-barcode') == 1)
			{
				$(".popup-qr .popup-qr__image").attr('src', '/ajax.php?mid=10&action=getGiftBarcode&id=' + id);
				$('.popup-qr__bar-caption').html(li.find('.barcode-data').html()).show();
			}
			else
			{
				$(".popup-qr .popup-qr__image").attr('src', '/ajax.php?mid=10&action=getGiftQRcode&id=' + id);
				$('.popup-qr__bar-caption').html('').hide();
			}
			$("body").addClass("no-scroll");
			$(".popup-qr").addClass("active");
		});

		$(".gifts-operations__item-instr").click(function (e){
			let li = $(this).closest('.gifts-operations__item');
			let id = li.attr('data-id');
			let html = li.find('.gifts-operations__item-hidden .gifts-operations__item-howtoget').html();
			let name = li.find('.gifts-operations__item-title').text();
			$(".popup-instr .gift-get-text").html(html);
			$(".popup-qr h3").text(name);
			$("body").addClass("no-scroll");
			$(".popup-instr").addClass("active");
		});


		$(".profile-data__block-edit--personal").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-personal").addClass("active");
		});

		$(".profile-data__block-edit--tel").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-tel").addClass("active");
		});

		$(".profile-data__block-edit--email").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-email").addClass("active");
		});

		$(".profile-data__block-edit--password").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-password").addClass("active");
		});

		$(".profile-data__block-edit--delete, .profile-data__revoke").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-delete").addClass("active");
		});

		$(".profile-data__delete-cancel").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-delete-cancel").addClass("active");
		});

		$(".auth-form__to-recover").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-recover").addClass("active");
		});

		$(".popup-password__to-recover").click(function (e){
			$(".popup-password").removeClass("active");
			$(".popup-recover").addClass("active");
		});

		$(".profile-data__social-add--vk, .profile-data__social-edit--vk").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-vk").addClass("active");
		});

		$(".profile-data__social-add--inst, .profile-data__social-edit--inst").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-inst").addClass("active");
		});

		$(".profile-data__social-add--fb, .profile-data__social-edit--fb").click(function (e){
			$("body").addClass("no-scroll");
			$(".popup-fb").addClass("active");
		});

		$(".profile-data__sent-mail").click(function (e){
			_this.resendConfirmMail();
		});

		if (window.location.hash.match(/^#show_gift_/))
		{
			let giftId = window.location.hash.replace(/^#show_gift_/, '');
			$('.gifts-operations__item[data-id=' + giftId + '] button.gifts-operations__item-qr').click();
		}
	}

}
